import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const services = [
  {
    tag: "Framework",
    title: "Four Lenses Classes",
    body: "Transform your understanding of personality and communication with our proven Four Lenses framework. Learn to recognize behavioral patterns and adapt your leadership style in real time.",
    img: "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    tag: "Consulting",
    title: "Custom Leadership Consulting",
    body: "Tailored consulting designed to address your organization's unique challenges — from team development and strategic planning to high-stakes decision-making.",
    img: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-28 sm:py-40 border-t border-white/10 bg-card/30" data-testid="services">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-20">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-primary">/ What We Offer</span>
            <h2 className="mt-6 font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-none">
              Precision <br /> leadership training
            </h2>
          </div>
          <p className="max-w-sm text-foreground/60 leading-relaxed">
            Two ways to work with us. Both built on the same discipline that keeps EOD operators
            steady when the stakes are absolute.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {services.map((s, i) => (
            <motion.a
              key={s.title}
              href="#contact"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative block border border-white/10 bg-background overflow-hidden"
              data-testid={`service-card-${i}`}
            >
              <div className="relative h-72 sm:h-96 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-[900ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
                <span className="absolute top-5 left-5 font-mono text-[11px] uppercase tracking-[0.25em] text-primary border border-primary/40 bg-background/60 backdrop-blur px-3 py-1.5">
                  {s.tag}
                </span>
              </div>
              <div className="p-8 sm:p-10">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl tracking-tight leading-none">
                    {s.title}
                  </h3>
                  <ArrowUpRight className="h-7 w-7 text-primary shrink-0 group-hover:rotate-45 transition-transform duration-300" />
                </div>
                <p className="mt-5 text-foreground/60 leading-relaxed">{s.body}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
